<template>
  <b-dropdown-item v-on="$listeners">
    <v-icon :name="icon" width="16" v-show="icon" />
    {{ text }}
  </b-dropdown-item>
</template>
<script>
export default {
  extends: "b-dropdown-item",
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "",
    },
  },
};
</script>
